import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import * as React from 'react';
import DemandSettingDataEdit from '../polling/pollingTopicEdit/DemandSettingDataEdit';

export type SelectDemandSettingDataDialogProps = {
    isOpen: boolean;
    onOK: (data: any) => void;
    onCancel: () => void;
    data: any;
};

export const SelectDemandSettingDataDialog = (props: SelectDemandSettingDataDialogProps) => {
    const { isOpen, onOK, onCancel, data } = props;
    const [open, setOpen] = React.useState(isOpen);

    // Cancelボタンイベント
    const handleCancel = () => {
        setOpen(false);
        onCancel();
    };

    const handleUpdate = (data: any) => {
        setOpen(false);
        onOK(data);
    };

    return (
        <div>
            <Dialog open={open} maxWidth={"md"} fullWidth>
                <DialogTitle>デマンド設定値</DialogTitle>
                <DialogContent sx={{ pb: 1.5 }}>
                    <DemandSettingDataEdit onCancel={handleCancel} demandSettingData={data} onOK={(data) => handleUpdate(data)}></DemandSettingDataEdit>
                </DialogContent>
            </Dialog>
        </div>
    );
}

export default SelectDemandSettingDataDialog;